import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {SalePeriodEntityModel} from "../sale-period-entity.model";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-sale-period-edit-page",
    templateUrl: "./sale-period-edit-page.component.html",
    providers: [provideEntityModel(SalePeriodEntityModel)]
})
export class SalePeriodEditPageComponent extends AbstractEditPage {
    EditMode = EditMode;

    constructor(public model: SalePeriodEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
